export const pluralizeUnit = (unit: string, quantity: number): string => {
  if (Math.abs(quantity) <= 1) {
    return unit;
  }

  const lowerUnit = unit.toLowerCase().trim();
  
  const invariableUnits = new Set([
    'kg', 'g', 'mg', 'l', 'ml', 'cl', 'dl',
    'cm', 'mm', 'm', 'km', 'm²', 'm³',
    'atom', 'moq', 'colis', 'u', 'ud', 'ul',
    '€', '$', '£', '%'
  ]);

  if (invariableUnits.has(lowerUnit)) {
    return unit;
  }

  const specialPlurals: Record<string, string> = {
    // Français
    'pièce': 'pièces',
    'piece': 'pieces', 
    'paquet': 'paquets',
    'lot': 'lots',
    'palette': 'palettes',
    'carton': 'cartons',
    'boîte': 'boîtes',
    'boite': 'boites',
    'pot': 'pots',
    'unité': 'unités',
    'unite': 'unites',
    'sachet': 'sachets',
    'flacon': 'flacons',
    'tube': 'tubes',
    'seau': 'seaux',
    
    // Anglais
    'box': 'boxes',
    'package': 'packages',
    'pallet': 'pallets',
    'item': 'items',
    'unit': 'units',
    
  };

  if (specialPlurals[lowerUnit]) {
    const pluralForm = specialPlurals[lowerUnit];
    
    if (unit === unit.toUpperCase()) {
      return pluralForm.toUpperCase();
    }
    if (/^[A-Z]/.test(unit)) {
      return pluralForm.charAt(0).toUpperCase() + pluralForm.slice(1);
    }
    return pluralForm;
  }

  if (unit.endsWith('s') || unit.endsWith('S')) {
    return unit;
  }

  return unit + 'S';
};